import React, { useEffect, useState } from "react";
import "./aboutbanner.css";

import Aos from "aos";
import "aos/dist/aos.css";
import Banner from "../Banner/Banner";

const AboutBanner = () => {
  const [activeTab, setActiveTab] = useState("trip");
  const [tripType, setTripType] = useState("oneway");
  const [travelTime, setTravelTime] = useState("exact");

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="aboutbanner">
      {/* الخلفية */}
     <Banner page="about" />
    </section>
  );
};

export default AboutBanner;
